// extracted by mini-css-extract-plugin
module.exports = {"cartIcon":"CartIcon_cartIcon__2Us1M","active":"CartIcon_active__34m5J"};